<template>
    <div class="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: 'App',
}
</script>
<style>
body,
html,
.app,
#app,
h3 {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
}
* {
    margin: 0;
    padding: 0;
}
body,
html {
    width: 100%;
    height: 100%;
    min-width: 1200px;
}
.el-popper {
    /* width: 60px     !important; */
    min-width: 0 !important;
}
/* @import url('~@/assets/self-adaption.scss'); */

</style>